import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { format } from 'date-fns'
import { randomInt } from '../helpers'
// import Settings from '../settings'

// This component has:
// 1. Events container
// 2. Events calendar as a list - css puts into colums

import IconSquare from './icons/IconSquare'

class SectionFeaturedEvents extends Component {

   componentDidMount() {

   }

   renderEvent = (event, i) => {
      // const { title, date, end_date, time, venue, event_description, links, gallery } = event
      const {
         // title = 'Test Event',
         date = '20171212',
         end_date = '20171230',
        //  time = '6pm',
         location = 'Carnegie Hall',
         description = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sint asperiores ratione ea nesciunt maxime, ab in, minima, quidem soluta dignissimos totam veritatis! Voluptatum provident repellat commodi excepturi earum expedita tempora.'.slice(0,randomInt(50,300)),// + '</p>',
        //  links = null,
      } = event
      const title = event.title.rendered

      const formatted_date = (end_date) ? format(date,'ddd M.D') +'–'+format(end_date,'ddd M.D') : format(date,'ddd M.D')

      return (
         <div key={i} className="list-event">
            <div className="event-inner">
               <div className="event-icon"><IconSquare size="12px"/></div>
               <div className="event-info">
                 <div className="event-title inline">
                    { formatted_date } {location} {title}&nbsp;
                 </div>
                 <div className="event-description inline">
                   <p className="inline">{ReactHtmlParser(description)}</p>
                 </div>
               </div>
            </div>
         </div>
      )
   }

   render() {
      // const {
      //   events = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]
      // } = this.props.data

      return (
         <div className="SectionListEvents"  id="event-calendar">

           {/* <h2 className="section-title page-width">Event Calendar</h2> */}

           <div className="list-events">
             <div className="list-events-inner page-width">
             { this.props.events.map((event, i) => !event.acf.featured_event && this.renderEvent(event, i)) }
             </div>
           </div>

         </div>
      )
   }
}

export default SectionFeaturedEvents



// WEBPACK FOOTER //
// ./src/components/SectionListEvents.js